import "./members.css";

const Members = () => {
  return (
    <div id="members" className="container members-container">
      <h1 className="member-txt">Projects</h1>
      <div className="member member-1">
        <div style={{background:` url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS78yzSGOZfnk1z0-oFIRqTJT1Qi1cfM70vYWKBEfzJJfrZn6xJ2HjdYPqtDpos1ofCZ_E&usqp=CAU)`}} className="member-img"></div>
        <div className="member-info">
          <h1 className="name">Electric Tools</h1>
          <h3 className="position">Admin Email: tanjinhossain2003@gmail.com</h3>
          <h3 className="position">Admin password: 000000</h3>
          <h4 className="about text-xl">
           This website have two different feature user or admin. user login normally but admin is require. A admin can make another admin and admin or user interface is different and it's interested.
          </h4>
          <a target='_black' rel="noreferrer" href="https://tools-a576c.web.app/" className="contact-member">
            <span>LiveSite</span>
          </a>
          <a target='_black' rel="noreferrer" href="https://github.com/Tanjinhossain1/electric-tools" className="text-white absolute mt-11 ml-32  py-4 px-6 rounded-full bg-[#320651] hover:bg-transparent duration-200 ease-in hover:border-2 hover:border-[#320651] ">
            <span>ClintSite Code</span>
          </a>
          <a target='_black' rel="noreferrer" href="https://github.com/Tanjinhossain1/electric-tools-server" className="text-white absolute mt-11 ml-72  py-4 px-6 rounded-full bg-[#320651] hover:bg-transparent duration-200 ease-in hover:border-2 hover:border-[#320651] ">
            <span>ServerSite Code</span>
          </a>
        </div>
      </div>
      <div className="member member-1">
        <div style={{background:` url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5BQt5_CNrXi_MINt36laV3VUnz81OstD8Vg&usqp=CAU)`}} className="member-img"></div>
        <div className="member-info">
          <h1 className="name">Book Warehouse</h1>
          <h3 className="position">Book warehouse management</h3>
          <h4 className="about text-xl">
           This website have book warehouse you can store you all book. You update you book or book quantity and also you can decrese you book quantity and add new book every user can see him/her specific book add show on myItem page.
          </h4>
          <a target='_black' rel="noreferrer" href="https://books-warehouse-edfd7.web.app/" className="contact-member">
            <span>LiveSite</span>
          </a>
          <a target='_black' rel="noreferrer" href="https://github.com/Tanjinhossain1/book-warehouse-managemant" className="text-white absolute mt-11 ml-32  py-4 px-6 rounded-full bg-[#320651] hover:bg-transparent duration-200 ease-in hover:border-2 hover:border-[#320651] ">
            <span>ClintSite Code</span>
          </a>
          <a target='_black' rel="noreferrer" href="https://github.com/Tanjinhossain1/book-server" className="text-white absolute mt-11 ml-72  py-4 px-6 rounded-full bg-[#320651] hover:bg-transparent duration-200 ease-in hover:border-2 hover:border-[#320651] ">
            <span>ServerSite Code</span>
          </a>
        </div>
      </div>
      <div className="member member-1">
        <div style={{backgroundImage:` url(https://www.muscleandfitness.com/wp-content/uploads/2018/12/Personal-Trainer-Training-Partner-GettyImages-654427364.jpg?quality=86&strip=all)`,
      background:'cover'
      }} className="member-img"></div>
        <div className="member-info">
          <h1 className="name">Gym Trainer</h1>
          <h3 className="position">Your Personal Gym Trainer</h3>
          <h4 className="about text-xl">
          This website on personal gym trainer you can login this page and select you trainer and see him/her detail and chose the trainer and contact him/her and enjoy you training.
          </h4>
          <a target='_black' rel="noreferrer" href="https://gym-trainer-a4e7b.web.app/" className="contact-member">
            <span>LiveSite</span>
          </a>
          <a target='_black' rel="noreferrer" href="https://github.com/Tanjinhossain1/specital-gym-trainer" className="text-white absolute mt-11 ml-32  py-4 px-6 rounded-full bg-[#320651] hover:bg-transparent duration-200 ease-in hover:border-2 hover:border-[#320651] ">
            <span>ClintSite Code</span>
          </a>
         
        </div>
      </div>

      

    </div>
  );
};

export default Members;
